<template>
    <div>
        <table v-if="!analytical" class="table b-table table-sm">
            <thead class="thead-dark">
                <tr>
                    <th class="text-center">Tipo</th>
                    <th v-for="range in ranges" class="text-center" colspan="4">{{ range.init_at | moment('DD/MM/YYYY') }} à {{ range.end_at | moment('DD/MM/YYYY') }}</th>
                    <th class="text-center" colspan="2">Total</th>
                </tr>
                <tr>
                    <th class="text-center">Vendedor</th>
                    <template v-for="range in ranges">
                        <th class="text-center">Cotas</th>
                        <th class="text-center">Valor das Cartas</th>
                        <th class="text-center">%</th>
                        <th class="text-center">Ticket Médio</th>
                    </template>
                    <th class="text-center">Cotas</th>
                    <th class="text-center">Valor das Cartas</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, name) in proposals">
                    <td>{{ name }}</td>
                    <template v-for="range in ranges">
                        <td class="text-center link" @click="showAnalitical(name, itensBetween(item, range.init_at, range.end_at), range.init_at, range.end_at)">{{ itensBetween(item, range.init_at, range.end_at).length }}</td>
                        <td class="text-center">R${{ sum(itensBetween(item, range.init_at, range.end_at), 'value') | price }}</td>
                        <td class="text-center">{{ (itensBetween(item, range.init_at, range.end_at).length / itensBetween(proposals, range.init_at, range.end_at).length) * 100 | price }}%</td>
                        <td class="text-center">R${{ sum(itensBetween(item, range.init_at, range.end_at), 'value') / (itensBetween(item, range.init_at, range.end_at).length || 1) | price }}</td>
                    </template>
                    <td class="text-center">{{ item.length }}</td>
                    <td class="text-center">R${{ sum(item, 'value') | price }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr role="row">
                    <td role="columnheader" scope="col"><strong>Totais</strong></td>
                    <template v-for="range in ranges">
                        <td role="columnheader" scope="col" class="text-center"><strong>{{ itensBetween(proposals, range.init_at, range.end_at).length }}</strong></td>
                        <td role="columnheader" scope="col" class="text-center"><strong>{{ sum(itensBetween(proposals, range.init_at, range.end_at), 'value') | price }}</strong></td>
                        <td class="text-center">-</td>
                        <td role="columnheader" scope="col" class="text-center"><strong>{{ sum(itensBetween(proposals, range.init_at, range.end_at), 'value') / (itensBetween(proposals, range.init_at, range.end_at).length || 1) | price }}</strong></td>
                    </template>
                    <td class="text-center">{{ count(proposals) }}</td>
                    <td class="text-center">R${{ sum(proposals, 'value') | price }}</td>
                </tr>
            </tfoot>
        </table>
        <table v-else class="table b-table table-sm">
            <thead class="thead-dark">
                <tr>
                    <th>Vendedor: {{ name }}</th>
                    <th colspan="3">Faixa: {{ initAt | moment('DD/MM/YYYY') }} à {{ endAt | moment('DD/MM/YYYY') }}</th>
                    <th>
                        <b-button size="sm" variant="dark" class='dont-print' @click='hideAnalitical()'>Voltar para Sintético</b-button>
                    </th>
                </tr>
                <tr class="thead-light">
                    <th class="text-center">Cliente</th>
                    <th class="text-center">Contrato</th>
                    <th class="text-center">Grupo</th>
                    <th class="text-center">Cota</th>
                    <th class="text-center">Valor da Carta</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection">
                    <td>{{ item.client }}</td>
                    <td class="text-center">{{ item.proposal }}</td>
                    <td class="text-center">{{ item.group }}</td>
                    <td class="text-center">{{ item.quota }}</td>
                    <td class="text-center">R${{ item.value | price }}</td>
                </tr>
                <tr v-if="collection.length == 0">
                    <td class="text-center" colspan="5">Nenhum item encontrado!</td>
                </tr>
            </tbody>
            <tfoot>
                <tr role="row">
                    <td role="columnheader" scope="col"><strong>Totais</strong></td>
                    <td class="text-center">{{ collection.length }}</td>
                    <td class="text-center">-</td>
                    <td class="text-center">-</td>
                    <td class="text-center">R${{ sum(collection, 'value') | price }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import groupBy from '@/helpers/groupBy.js';
    import Vue from 'vue';

    export default {
        computed: {
            proposals: {
                get() {
                    const groupByName = groupBy('name');
                    if (this.items) {
                        return groupByName(this.items);
                    } else {
                        return [];
                    }
                }
            }
        },
        data() {
            return {
                analytical: false,
                init_at: null,
                end_at: null,
                form: {},
                collection: [],
                ranges: []
            };
        },
        methods: {
            breakMonths() {
                var self = this;
                var init_at = Vue.moment(self.form.date_at[0]);
                var end_at = Vue.moment(self.form.date_at[1]);
                var aux = Vue.moment(init_at);

                do {
                    aux.add(1, 'month');
                    self.ranges.push({
                        init_at: Vue.moment(init_at),
                        end_at: Vue.moment(aux).add(-1, 'day')
                    });
                    init_at = Vue.moment(aux);
                } while (aux < end_at);
            },
            count(_proposals){
                var count = 0;

                for (let [key, items] of Object.entries(_proposals)) {
                    count += items.length;
                }

                return count;
            },
            hideAnalitical() {
                this.analytical = false;
            },
            itensBetween(_proposals, _initAt, _endAt) {
                var proposals = [];

                if (Array.isArray(_proposals)) {
                    _proposals.forEach(function (_proposal) {
                        var saleAt = Vue.moment(_proposal.sale_at);
                        if (_initAt <= saleAt && saleAt <= _endAt) {
                            proposals.push(_proposal);
                        }
                    });
                } else {
                    for (let [key, items] of Object.entries(_proposals)) {
                        items.forEach(function (_proposal) {
                            var saleAt = Vue.moment(_proposal.sale_at);
                            if (_initAt <= saleAt && saleAt <= _endAt) {
                                proposals.push(_proposal);
                            }
                        });
                    }
                }

                return proposals;
            },
            showAnalitical(_name, _proposals, _initAt, _endAt) {
                var self = this;

                self.name = _name;
                self.collection = _proposals;
                self.initAt = _initAt;
                self.endAt = _endAt;

                self.analytical = true;
            },
            sum(_proposals, _reducer) {
                var sum = 0;

                if (Array.isArray(_proposals)) {
                    _proposals.forEach(function (_proposal) {
                        sum += parseFloat(_proposal[_reducer]);
                    });
                } else {
                    for (let [key, items] of Object.entries(_proposals)) {
                        items.forEach(function (_proposal) {
                            sum += parseFloat(_proposal[_reducer]);
                        });
                    }
                }

                return sum;
            },
            reportData() {
                 var self = this;

                return {
                    'headers': self.ranges.map(range => `${range.init_at.format('DD/MM/YYYY')} à ${range.end_at.format('DD/MM/YYYY')}`),
                    'rows': Object.entries(self.proposals).map(entry => {
                        const salesman = entry[0];
                        const proposals = entry[1];
                        return {
                            'salesman': salesman,
                            'columns': self.ranges.map(range => {
                                return {
                                    'proposals_amount': self.itensBetween(proposals, range.init_at, range.end_at).length,
                                    'total_value': self.sum(self.itensBetween(proposals, range.init_at, range.end_at), 'value'),
                                    'global_percent': (self.itensBetween(proposals, range.init_at, range.end_at).length / (self.itensBetween(self.proposals, range.init_at, range.end_at).length || 1)) * 100,
                                    'value_average': self.sum(self.itensBetween(proposals, range.init_at, range.end_at), 'value') / (self.itensBetween(proposals, range.init_at, range.end_at).length || 1),
                                };
                            }),
                            'totals' : {
                                'proposals_amount': proposals.length,
                                'total_value': self.sum(proposals, 'value'),
                            },
                        };
                    }),
                    'totals': {
                        'columns': self.ranges.map(range => {
                            return {
                                'proposals_amount': self.itensBetween(self.proposals, range.init_at, range.end_at).length,
                                'total_value': self.sum(self.itensBetween(self.proposals, range.init_at, range.end_at), 'value'),
                                'value_average': self.sum(self.itensBetween(self.proposals, range.init_at, range.end_at), 'value') / (self.itensBetween(self.proposals, range.init_at, range.end_at).length || 1),
                            };
                        }),
                        'totals': {
                            'proposals_amount': self.count(self.proposals),
                            'total_value': self.sum(self.proposals, 'value'),
                        },
                    },
                };
            },
        },
        mounted() {
            var self = this;

            self.form = JSON.parse(self.$route.query.form);

            self.breakMonths();

            self.hideAnalitical()
        },
        props: ['items']
    };
</script>